import React, { useState } from "react";
import { COLORS, RADIUS, SHADOW } from "../../theme";

export default function Input({ label, style, ...props }) {
  const [focused, setFocused] = useState(false);

  return (
    <div>
      {label && (
        <label style={{ fontSize: 12, fontWeight: 600, color: COLORS.textMid, display: "block", marginBottom: 6 }}>
          {label}
        </label>
      )}
      <input
        onFocus={(e) => {
          setFocused(true);
          props.onFocus && props.onFocus(e);
        }}
        onBlur={(e) => {
          setFocused(false);
          props.onBlur && props.onBlur(e);
        }}
        style={{
          width: "100%",
          boxSizing: "border-box",
          border: `1.5px solid ${focused ? COLORS.borderFocus : COLORS.border}`,
          borderRadius: RADIUS.md,
          padding: "11px 14px",
          fontSize: 14,
          background: COLORS.bg,
          color: COLORS.text,
          outline: "none",
          transition: "border .15s, box-shadow .2s",
          boxShadow: focused ? SHADOW.focus : "none",
          ...style,
        }}
        {...props}
      />
    </div>
  );
}
